/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Container,CardTitle,CardFooter,
  Row,
  Col
} from "reactstrap";
// core components
import { connect } from "react-redux";
import GeneralHeader from "components/Headers/GeneralHeader";
import axios from 'axios';
import {addGrades,addSelectedSubject} from 'actions/index';
import Loader from 'react-loader-spinner';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MarkedTable from "./tables/MarkedTable";

const mapStateToProps = state => ({
  grades: state.grades,subject_selected:state.subject_selected,user:state.user
});

function mapDispatchToProps(dispatch) {
  return {
    addGrades: grades => dispatch(addGrades(grades)),addSelectedSubject: subject=>dispatch(addSelectedSubject(subject))
  };
}

class Marked extends React.Component {
  constructor(props) {
    super(props);
    this.state = {       
     subjects:[],
     grades:[],
     subjectClicked:false,
     grade_name:'',
     available_scripts:[],
     scriptsLoaded:false,
     subjectsLoaded:false,
     generateCards:true,
     gradesLoading:true,
     gradesError:false,
     subjectsLoading:false,
     subject_selected:'',
     goBackToSubjects:false,
     user:this.props.user,
     marker_codes:[]
    }; 
    this.generateCards = this.generateCards.bind(this);
    this.getGradeSubjects = this.getGradeSubjects.bind(this);
    this.generateSubjectCards = this.generateSubjectCards.bind(this);
    this.getAvailableScripts = this.getAvailableScripts.bind(this);
    this.getGrades = this.getGrades.bind(this);
    this.goToGrades = this.goToGrades.bind(this);
    this.subjectGoBack = this.subjectGoBack.bind(this);
    this.getMarkerCodes = this.getMarkerCodes.bind(this);
    this.getGradesAdmin = this.getGradesAdmin.bind(this);
    this.getGradeSubjectsAssigned = this.getGradeSubjectsAssigned.bind(this);
  }

  componentDidMount(){
    // //console.log('props state checking',this.props);    
    this.setState({full_name:localStorage.getItem('full_name')});    
    this.loadGrades();
  } 

  // Admins do not need marker codes (their grade counts come from an admin endpoint), so a
  // marker-portal-backend failure must not leave the page blank for them.
  loadGrades(){
    this.setState({gradesLoading:true,gradesError:false});
    if(localStorage.getItem('userRole')==='app-admin'){
      this.getGradesAdmin();
    }else{
      this.getMarkerCodes();
    }
  }

  
  getMarkerCodes(){
    let user_id = localStorage.getItem('user_id');
    let token = localStorage.getItem('access_token');
        axios.get('https://markerportalbackend.thinkdigitalacademy.org/api/get-user-marker-codes/'+user_id, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then(res => {
            // //console.log('marker codes', res.data);
            if(!Array.isArray(res.data.marker_codes)){
              this.setState({gradesLoading:false,gradesError:true});
              toast('Could not load your marker codes ('+(res.data.status||'unexpected response')+'). Please log in again.', {position: "top-right",autoClose: 5000,type: toast.TYPE.ERROR});
              return;
            }
            this.setState({marker_codes: res.data.marker_codes});
            this.getGrades();

        }).catch(error => {
            // //console.log('error', error);
            this.setState({gradesLoading:false,gradesError:true});
            toast('An error occurred getting marer codes.'+error, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              type: toast.TYPE.ERROR
          });
        });
  }

  goToGrades(){
    this.setState({subjectsLoaded:false,generateCards:true,subjectClicked:false,goBackToSubjects:false,scriptsLoaded:false});
  }

  subjectGoBack(){
    this.setState({subjectsLoaded:true,generateCards:false,subjectClicked:true,goBackToSubjects:true,scriptsLoaded:false});
  }

  getGradesAdmin() {
    
    axios({
      headers: {
          'content-type': 'application/json'
      },
      method: 'get',
      url: 'https://admin.thinkdigitalacademy.org/api/get-grades-marked-assigned-admin',
      
  }).then(res => {
      // //console.log(res);
      this.props.addGrades(res.data.grades);   
       this.setState({grades:res.data.grades,goBackToSubjects:false,gradesLoading:false});
         
  }).catch(error => {
      this.setState({gradesLoading:false,gradesError:true});
      toast('An error occurred getting grades.'+error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        type: toast.TYPE.ERROR
    });
  });
   
  }

  getGrades() {
    let data = {
      marker_codes:this.state.marker_codes
    };

    axios({
      headers: {
          'content-type': 'application/json'
      },
      method: 'post',
      url: 'https://admin.thinkdigitalacademy.org/api/get-grades-marked-assigned',
      data: data
  }).then(res => {
      // //console.log(res);
      this.props.addGrades(res.data.grades);   
       this.setState({grades:res.data.grades,goBackToSubjects:false,gradesLoading:false});
         
  }).catch(error => {
      this.setState({gradesLoading:false,gradesError:true});
      toast('An error occurred getting grades.'+error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        type: toast.TYPE.ERROR
    });
  });
   
  }
  
  getGradeSubjectsAssigned(id){
    let data = {
      grade_id:id
    };

    axios({
      headers: {
          'content-type': 'application/json'
      },
      method: 'post',
      url: 'https://admin.thinkdigitalacademy.org/api/get-grade-subjects-assigned-marked-admin',
      data: data
  }).then(res => {
     
      this.setState({subjectsLoading:false,subjects:res.data.subjects,subjectClicked:true,grade_name:res.data.grade_name,generateCards:false,goBackToSubjects:true});
 
  }).catch(error => {
      toast('An error occurred getting subjects.'+error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        type: toast.TYPE.ERROR
    });
  });
}

  getGradeSubjects(id){

    if(localStorage.getItem('userRole')=='app-admin'){
      this.getGradeSubjectsAssigned(id)
    }else{

    let data = {
      marker_codes:this.state.marker_codes,
      grade_id:id
    };

    axios({
      headers: {
          'content-type': 'application/json'
      },
      method: 'post',
      url: 'https://admin.thinkdigitalacademy.org/api/get-grade-subjects-assigned-marked',
      data: data
  }).then(res => {
        
      this.setState({subjectsLoading:false,subjects:res.data.subjects,subjectClicked:true,grade_name:res.data.grade_name,generateCards:false,goBackToSubjects:true});
 
  }).catch(error => {
      toast('An error occurred getting subjects.'+error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        type: toast.TYPE.ERROR
    });
  });  

  }
}

  generateCards() {
    return this.state.grades.map((prop, key) => {
     
      return (
        <Col lg={4} key={key}>
        <Card  className="card-stats mb-4 mb-xl-0" style={{ marginTop: "2em" }}>
                    <CardBody>
                      <Row>
                        <div className="col">
                          <CardTitle
                            tag="h5"
                            className="text-uppercase text-muted mb-0"
                          >
                           {prop.grade_name}
                          </CardTitle>
                          <span className="h2 font-weight-bold mb-0">
                           {prop.uploads}
                          </span>
                        </div>
                        {   
                          prop.grade_name.includes('Grade')&&<Col className="col-auto">
                          <div className="icon icon-shape bg-success text-white rounded-circle shadow">
                            <i className="ni ni-bullet-list-67" />
                          </div>
                        </Col>
                        }
                        {   
                          prop.grade_name.includes('Graad')&&<Col className="col-auto">
                          <div className="icon icon-shape bg-warning text-white rounded-circle shadow">
                            <i className="ni ni-bullet-list-67" />
                          </div>
                        </Col>
                        }
                      </Row>
                    </CardBody>
                    <CardFooter>
                    <Button onClick={(e) => this.getGradeSubjects(prop.id)} outline color="info" outline type="button">
                      View
                    </Button>
                    </CardFooter>
                  </Card>
        </Col>
      );
    });
  };

  getAvailableScripts(id,e){
    
    this.setState({scriptsLoaded:true,subjectClicked:false,subject_selected:id}); 
    this.props.addSelectedSubject(id);
  }

  generateSubjectCards() {
    return this.state.subjects.map((prop, key) => {
     
      return (
        <Col lg={4} key={key}>
        <Card  className="card-stats mb-4 mb-xl-0" style={{ marginTop: "2em" }}>
                    <CardBody>
                      <Row>
                        <div className="col">
                          <CardTitle
                            tag="h5"
                            className="text-uppercase text-muted mb-0"
                          >
                           {prop.name}
                          </CardTitle>
                          <span className="h2 font-weight-bold mb-0">
                           {prop.uploads}
                          </span>
                        </div>
                        <div className="icon icon-shape bg-success text-white rounded-circle shadow">
                            <img src={`https://think-digital-production.s3.eu-west-1.amazonaws.com/`+prop.picture} width={60} />
                          </div>
                      </Row>
                    </CardBody>
                    <CardFooter>
                    <Button onClick={(e) => this.getAvailableScripts(prop.id, e)} outline color="info" outline type="button">
                      View
                    </Button>
                    </CardFooter>
                  </Card>
        </Col>
      );
    });
  };
  render() {
    return (
      <>
       <GeneralHeader/>
       <Container className="mt--7" fluid>
          <Row>
            
            <Col className="order-xl-1" xl="12">
              <Card className="bg-secondary shadow">
                <CardHeader className="bg-white border-0">
                  <Row>
                    <Col xs={2}>
                      <>
                   {this.state.subjectClicked && !this.state.scriptsLoaded && <Button size="sm"  color="success" type="button" onClick={this.goToGrades}>
                    Back
                  </Button>
                  } 
                  {this.state.goBackToSubjects && !this.state.subjectClicked && <Button size="sm"  color="success" type="button" onClick={this.subjectGoBack}>
                    Back
                  </Button>
                  } 
</>
                    </Col>
                <Col xs="9">  
                <div className="text-center">              
                  {
                    this.state.subjectClicked && <h3 className="mb-0">Select Subject</h3>
                  } 
                  </div>                   
                    </Col>
                    <Col xs="1">
                      {
                        this.state.subjectClicked=== true? <span className='badge badge-info'>{this.state.grade_name}</span>:''
                      }
                      
                    </Col></Row>
                </CardHeader>
                <CardBody>
                  {
                    this.state.gradesLoading===true?<Loader type="Puff" color="#00BFFF"
                    height={100}
                    width={100}
                    timeout={3000}
                    //3 secs
                />:<>{
                  this.state.gradesError===true&&<div className="text-center py-4">
                    <p className="text-danger mb-3">Marked scripts could not be loaded.</p>
                    <Button color="info" size="sm" type="button" onClick={()=>this.loadGrades()}>Retry</Button>
                  </div>
                }{
                  this.state.generateCards===true&&<Row>
                   {this.generateCards()}
                    </Row>
                }
                </>
                  }
                  {
                    this.state.subjectsLoading===true?<Loader type="Puff" color="#00BFFF"
                    height={100}
                    width={100}
                    timeout={3000}
                    //3 secs
                />:<>
                {
                    this.state.subjectClicked===true&& <Row>{this.generateSubjectCards()}</Row>
                  }
                </>
                  }                  
                  
                    {
                    this.state.scriptsLoaded&& <MarkedTable selected_subject={this.state.selectedSubject}/>
                  }            
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}
export default connect(mapStateToProps,mapDispatchToProps)(Marked);
